// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/support_settings.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";
import { SupportAccessState, supportAccessStateFromJSON, supportAccessStateToJSON } from "./tenancy";

export const protobufPackage = "models";

/** SupportSettings holds support access configuration for an org. */
export interface SupportSettings {
  supportAccessState: SupportAccessState;
  /** Time that support access begins. */
  supportAccessStartTs:
    | Date
    | undefined;
  /** Time that support access ends. */
  supportAccessEndTs: Date | undefined;
}

function createBaseSupportSettings(): SupportSettings {
  return { supportAccessState: 0, supportAccessStartTs: undefined, supportAccessEndTs: undefined };
}

export const SupportSettings: MessageFns<SupportSettings> = {
  encode(message: SupportSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.supportAccessState !== 0) {
      writer.uint32(8).int32(message.supportAccessState);
    }
    if (message.supportAccessStartTs !== undefined) {
      Timestamp.encode(toTimestamp(message.supportAccessStartTs), writer.uint32(18).fork()).join();
    }
    if (message.supportAccessEndTs !== undefined) {
      Timestamp.encode(toTimestamp(message.supportAccessEndTs), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SupportSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSupportSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.supportAccessState = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.supportAccessStartTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.supportAccessEndTs = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SupportSettings {
    return {
      supportAccessState: isSet(object.supportAccessState) ? supportAccessStateFromJSON(object.supportAccessState) : 0,
      supportAccessStartTs: isSet(object.supportAccessStartTs)
        ? fromJsonTimestamp(object.supportAccessStartTs)
        : undefined,
      supportAccessEndTs: isSet(object.supportAccessEndTs) ? fromJsonTimestamp(object.supportAccessEndTs) : undefined,
    };
  },

  toJSON(message: SupportSettings): unknown {
    const obj: any = {};
    if (message.supportAccessState !== 0) {
      obj.supportAccessState = supportAccessStateToJSON(message.supportAccessState);
    }
    if (message.supportAccessStartTs !== undefined) {
      obj.supportAccessStartTs = message.supportAccessStartTs.toISOString();
    }
    if (message.supportAccessEndTs !== undefined) {
      obj.supportAccessEndTs = message.supportAccessEndTs.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SupportSettings>, I>>(base?: I): SupportSettings {
    return SupportSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SupportSettings>, I>>(object: I): SupportSettings {
    const message = createBaseSupportSettings();
    message.supportAccessState = object.supportAccessState ?? 0;
    message.supportAccessStartTs = object.supportAccessStartTs ?? undefined;
    message.supportAccessEndTs = object.supportAccessEndTs ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
